import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { DriverSettings, DEFAULT_SETTINGS } from '../types';
import { getSettings, saveSettings as saveSettingsToDb } from '../services/storage';

interface SettingsContextType {
  settings: DriverSettings;
  isLoading: boolean;
  saveSettings: (settings: DriverSettings) => Promise<void>;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<DriverSettings>(DEFAULT_SETTINGS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const loaded = await getSettings();
      setSettings(loaded);
    } catch (error) {
      console.error('Failed to load settings:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveSettings = async (newSettings: DriverSettings) => {
    await saveSettingsToDb(newSettings);
    setSettings(newSettings);
  };

  return (
    <SettingsContext.Provider value={{ settings, isLoading, saveSettings: handleSaveSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
}





























